import React, {FunctionComponent} from "react";

interface Props {
    sellerUrl: string | undefined;
}
export const OldProductLayer: FunctionComponent<Props> = ({sellerUrl}) => {
    return (
        <div className="old-product">
            <p>
                En lien avec la loi AGEC (Anti-Gaspillage pour une Économie Circulaire),
                BUT s'engage tout au long de l'année dans{" "}
                <strong>
                    la collecte sélective et la revalorisation de vos produits concernés
                    par les filières à responsabilité élargie des producteurs (REP) :
                </strong>
            </p>
            <ul>
                <li>Les Eléments d'ameublement (DEA)</li>
                <li>Les Équipements Électriques et Électroniques (DEEE)</li>
                <li>Les produits textiles (TLC)</li>
                <li>
                    Les articles de sport et de loisirs (ASL)| ? Les articles de bricolage
                    et de jardin (ABJ)|
                </li>
                <li>Les jouets</li>
            </ul>
            <p>
                Vous pouvez déposer votre ancien produit dans l'un des{" "}
                <strong>points de collecte</strong> organisés par les éco-organismes ou{" "}
                <strong>en faire don à une structure à vocation sociale</strong> si
                celui-ci est encore en bon état (Par exemple, Emmaus, Envie...) :
            </p>
            <ul>
                <li>
                    Pour les éléments d'ameublement et de décoration textile, les jeux et
                    les jouets, et les articles de bricolage et de jardin :
                    <a
                        href="https://ecomaison.com/acceder-a-nos-points-de-collecte-pres-de-chez-vous/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        https://ecomaison.com/acceder-a-nos-points-de-collecte-pres-de-chez-vous/
                    </a>
                </li>
                <li>
                    Pour les équipements électriques et électroniques :&nbsp;
                    <a
                        href="https://www.ecosystem.eco/"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        ecosystem.eco
                    </a>
                </li>
                <li>
                    Pour les articles de sport et de loisirs :
                    <a
                        href="https://www.ecologic-france.com/citoyens/ou-deposer-mes-articles-de-sport-et-loisirs-usages.html"
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        https://www.ecologic-france.com/citoyens/ou-deposer-mes-articles-de-sport-et-loisirs-usages.html
                    </a>
                </li>
            </ul>
            <p style={{paddingBottom: '16px !important'}}>
                Pour l’achat d’un produit marketplace, les modalités de reprise peuvent varier selon le vendeur, le mode
                de livraison et les dimensions du produit acheté.
                {/*TODO decade dynamiser le product_vendor_id*/}
                {sellerUrl && <a
                    href={sellerUrl + '#shippingsInformationsBloc'}
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    Voir les conditions de reprise du vendeur
                </a>}
            </p>
            <p>
                Pour un produit volumineux (supérieur à 30 kg et dimensions supérieures
                à 2 mètres), la reprise se fera dans les mêmes conditions que la
                livraison, à condition que le produit à reprendre soit de nature et de
                dimensions équivalentes à celui acheté, et qu'il soit éligible à l'une
                des filières de Responsabilité Élargie des Producteurs (REP) mentionnées
                précédemment.
            </p>
            <p>
                Pour toutes demandes d’informations complémentaires, consultez notre FAQ
                :
                <a
                    href="https://www.but.fr/aide"
                    target="_blank"
                    rel="noopener noreferrer"
                >
                    https://www.but.fr/aide
                </a>
            </p>
        </div>
    );
}